/**
 * Returns a callback to update the selected state of the
 * component based on multiple checked inputs.
 * @param {Element} select
 * @returns {Function} A callback function
 */
const handleMultiSelection = (select) => () => {
    const selected = $(select).find('input:checked').length > 0;

    $(select).attr('data-selected', selected);
};

export default handleMultiSelection;



// WEBPACK FOOTER //
// ./src/scripts/components/select/handleMultiSelection.js